import { Component } from 'react';
import { $logger } from '../controllers/logger/logger.js';

class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = { error: false };
    }
    static getDerivedStateFromError() {
        return { error: true };
    }
    componentDidCatch(error) {
        $logger.fatal(error.message);
    }
    render() {
        if (this.state.error)
            return null;
        return this.props.children;
    }
}

export { ErrorBoundary };
//# sourceMappingURL=error-boundary.js.map
